import PropTypes from 'prop-types';
import { deviseSignIn } from '@polydice/icook-devise-unify';
import { webviewTrack } from 'components/webviewTrack';
import styles from './ProductCoupon.module.scss';
import Button from '@polydice/ui/dist/Button';
import { triggerSimpleDialog } from '@polydice/ui/dist/Dialog';
import classNames from 'classnames';

const VIPModal = ({ darkMode }) => {
  const goToVIP = () => {
    window.location.assign(
      'https://icook.tw/vip?ref=vip-cta-marketcoupon-show'
    );
  };

  return (
    <section className={styles.productCouponModal}>
      <div className={styles.productCouponModalImage} />
      <p
        className={classNames(styles.productCouponModalContent, {
          'dark-mode gray2-bgc': darkMode
        })}
      >
        購買愛料理市集限定商品，享受優惠折扣與超值贈品。還有不定期的抽獎活動、免費索取試用及各式體驗活動。
      </p>
      <Button
        name="button"
        styleType="contained"
        color="primary"
        fullWidth
        onClick={goToVIP}
        className={classNames({ 'dark-mode blue-button': darkMode })}
      >
        立即升級 VIP
      </Button>
    </section>
  );
};

const ProductCoupon = ({ user, coupon, darkMode }) => {
  const handleLogin = () => {
    const name = 'member_feature_requirement_label_clicked';
    const parameters = JSON.stringify({ where: 'make_order', label: 'log_in' });
    webviewTrack(name, parameters);
    deviseSignIn({
      entry: 'market_product_coupon',
      redirect: window.location.href,
      in_web: 1
    });
  };

  const openVIPDialog = () => {
    triggerSimpleDialog({
      title: 'VIP 專屬優惠',
      focusDomSelector: '[name=button]',
      withCloseIconButton: true,
      children: <VIPModal darkMode={darkMode} />
    });
  };

  let couponNode;
  if (coupon.vip_only && !user) {
    couponNode = (
      <button
        type="button"
        className={classNames(styles.productCouponAction, {
          'dark-mode blue-button': darkMode
        })}
        onClick={handleLogin}
      >
        登入使用
      </button>
    );
  } else if (coupon.vip_only && user && !user.vip) {
    couponNode = (
      <button
        type="button"
        className={classNames(styles.productCouponAction, {
          'dark-mode blue-button': darkMode
        })}
        onClick={openVIPDialog}
      >
        升級VIP
      </button>
    );
  } else {
    couponNode = <span>優惠券已套用</span>;
  }

  return (
    <section
      className={classNames(styles.productCoupon, {
        'dark-mode gray2-bgc no-border': darkMode
      })}
    >
      {couponNode}
    </section>
  );
};

ProductCoupon.propTypes = {
  user: PropTypes.shape({
    vip: PropTypes.bool
  }),
  coupon: PropTypes.shape({
    vip_only: PropTypes.bool
  })
};

ProductCoupon.defaultProps = {
  user: null,
  coupon: null
};

export default ProductCoupon;
